// extracted by mini-css-extract-plugin
export default {"this":"Gente_this__MI7fu"};